import { createContext, useContext, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, type Session } from "./api";

const Ctx = createContext<Session | null>(null);

export function useSessionQuery() {
  return useQuery({ queryKey: ["session"], queryFn: () => api<Session>("/api/session"), staleTime: 60_000 });
}

export function SessionProvider({ value, children }: { value: Session; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useSession(): Session {
  const s = useContext(Ctx);
  if (!s) throw new Error("useSession outside provider");
  return s;
}

export function useCan() {
  const s = useSession();
  const set = new Set(s.permissions ?? []);
  return (perm: string) => set.has(perm);
}
